module.exports = __webpack_public_path__ + "img/7.22ef86ca.png";